import LevelSelector from './LevelSelector';
import SearchBox from './SearchBox';
import ThemeSelector from './ThemeSelector';
import constants from '../../config/constants';

const { subHeaderHeight } = constants;

const useStyles = () => ({
  container: {
    display: 'flex',
    height: subHeaderHeight,
    width: '100%',
    padding: '0 20px',
    alignItems: 'center',
    marginTop: 15,
    gap: 20,
    zIndex: 2,
  },
});

const MainControlsDesktop = () => {
  const styles = useStyles();
  return (
    <div id="main-controls-container" style={styles.container}>
      <ThemeSelector />
      <LevelSelector />
      <SearchBox />
    </div>
  );
};

export default MainControlsDesktop;
